// @flow
import Account from '../presentational/Account.jsx'
import withUser from '../hocs/withUser'

export default withUser()(Account)
